import { render, staticRenderFns } from "./MaquinasBitacora.vue?vue&type=template&id=664cbbf9&"
import script from "./MaquinasBitacora.vue?vue&type=script&lang=js&"
export * from "./MaquinasBitacora.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports